module.exports = __webpack_public_path__ + "static/media/gridItem4.0b503c2a.jpg";